import {
	ReactElement,
	useMemo,
	useState
} from "react";
import { BusyIndicator } from "client/Components";
import { GlobalNavigationSidebar } from "client/Features/Layout/GlobalNavigationSidebar/GlobalNavigationSidebar";
import { localize } from "client_legacy/ndaw/culture";
import { AppType } from "client/Api/Apps/common";
import { Action, ActionKind } from "client_legacy/ndaw/actions";
import { useHandleNavigationInGlobalSubNavigation } from "client/Features/Layout/GlobalNavigationSidebar/useGlobalNavigationVisibilityState";

export type EmailSidebarContentFactory = (
	onIsLoadingChange: (value: boolean) => void,
	onSidebarNavigation: () => void
) => ReactElement | null;

export type EmailSidebarProps = {
	onManageMailboxes(): void;
	children: EmailSidebarContentFactory;
};

export const EmailSidebar = (props: EmailSidebarProps): ReactElement => {
	const {
		onManageMailboxes,
		children
	} = props;
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const handleNavigationInGlobalSubNavigation: () => void = useHandleNavigationInGlobalSubNavigation();

	const actions = useMemo(
		(): readonly Action<undefined>[] => ([
			{
				kind: ActionKind.Regular,
				icon: "gear",
				canExecute: () => true,
				execute: (): void => {
					onManageMailboxes();
					handleNavigationInGlobalSubNavigation();
				},
				name: "manage-mailboxes",
				title: localize("_Manage")
			}
		]),
		[
			handleNavigationInGlobalSubNavigation,
			onManageMailboxes
		]
	);

	return (
		<GlobalNavigationSidebar.ActivePanelOverride
			title={localize("_Email")}
			kind={AppType.Email}
			actions={actions}
			actionContext={undefined}
		>
			{isLoading && <BusyIndicator />}
			{children(setIsLoading, handleNavigationInGlobalSubNavigation)}
		</GlobalNavigationSidebar.ActivePanelOverride>
	);
};

EmailSidebar.displayName="EmailSidebar";